/* eslint import/no-webpack-loader-syntax: off */
require('expose-loader?BVHOCs!hocs');
require('expose-loader?BVComponents!components');
require('expose-loader?BVHooks!hooks');
require('expose-loader?BVContexts!contexts');
require('expose-loader?BVMetas!metas');
